module.exports = __webpack_public_path__ + "img/underarmThrowText1.2013b693.png";